document.addEventListener('DOMContentLoaded', formHandling);

function formHandling()
{
    handleFormSubmitWithRedirect("newsletteranmeldung_");
    handleFormSubmitWithRedirect("newsletternachqualifizierung_");
    handleFormSubmitWithSuccessMessage("newsletterabmeldung_");
}


/**
 * Handles a form submission that switches a surrounding state container between
 * "form" (initial), "loading", "success" and "error".
 *
 * The form must be nested inside an element that carries a `data-state` attribute
 * (e.g. `<dic data-state="form">`). Visibility of the individual
 * blocks (form content, loading indicator, success message, error message) is
 * expected to be controlled via CSS reacting to that attribute (see the Tailwind
 * `group-data-[state=…]` variants used in the fusion templates).
 *
 * @param {string}   formId              - ID of the <form> element
 * @param {object}   [options]
 * @param {function} [options.onSuccess] - optional callback executed after success state is set
 */
function handleFormSubmitWithSuccessMessage(formId, { onSuccess } = {})
{
    const form = document.querySelector("#" + formId);
    if (!form)
    {
        return;
    }
    const stateContainer = form.closest("[data-state]");
    if (!stateContainer)
    {
        return;
    }

    form.addEventListener("submit", (event) => {
        event.preventDefault();
        stateContainer.dataset.state = "loading";

        const apiUrl = form.getAttribute("data-api-url");
        const formData = new FormData(form);

        fetch(apiUrl, {
            method: "POST",
            body: formData,
        }).then(
            result => {
                if (!result.ok)
                {
                    throw new Error(result.statusText);
                }
                stateContainer.dataset.state = "success";
                onSuccess?.();
            }
        ).catch(
            () => {
                stateContainer.dataset.state = "error";
            }
        );
    });
}

function handleFormSubmitWithRedirect(formId)
{
    const form = document.querySelector("#" + formId);
    const form_error = document.querySelector("#" + formId + "error");
    const form_loading = document.querySelector("#" + formId + "loading");
    if(!form)
    {
        return;
    }
    form.addEventListener("submit", (event) => {
        event.preventDefault();
        const clicked_button = document.activeElement;

        addClass(form_error, "hidden");
        removeClass(form_loading, "hidden");
        if(form_loading)
        {
            addClass(clicked_button, "hidden");
        }
        const apiUrl = form.getAttribute("data-api-url");
        const redirectUrl = form.getAttribute("data-redirect");
        const formData = new FormData(form);

        fetch(apiUrl, {
            method: "POST",
            body: formData,
        }).then(
            result => {
                if(!result.ok)
                {
                    throw new Error(result.statusText);
                }
                if(redirectUrl)
                {
                    location.href = redirectUrl
                }
            }
        ).catch(
            () => {
                addClass(form_loading, "hidden");
                removeClass(clicked_button, "hidden");
                removeClass(form_error, "hidden");
            }
        );
    });

}

const addClass = (element, className) => element?.classList.add(className);
const removeClass = (element, className) => element?.classList.remove(className);
